import * as React from "react";

import { cn } from "@/lib/utils";

const InputError = React.forwardRef<
	HTMLParagraphElement,
	React.ComponentProps<"p">
>(({ className, children, ...props }, ref) => {
	return (
		<p
			ref={ref}
			{...props}
			className={cn("text-destructive text-sm", className)}
		>
			{children}
		</p>
	);
});
InputError.displayName = "Input-Error";

export { InputError };
